import { config } from "../env";
import { Delete, get, patch, post } from "./helpers/http-handler";

export const adminCreateGroup = (payload: object) =>
	post(`${config.API_URL}/groups`, payload);

export const adminGetGroups = (queryRequest:string) => get(`${config.API_URL}/groups?${queryRequest}`);

export const adminGetSpecificGroup= (id: string) =>
	get(`${config.API_URL}/groups/${id}`);

export const adminUpdateSpecificGroup = (id: string, payload: object) =>
	patch(`${config.API_URL}/groups/${id}`, payload);

export const adminDeleteSpecificGroup = (id: string) =>
	Delete(`${config.API_URL}/groups/${id}`);

	export const adminUpdateBulkGroupStatus = ( payload: object) =>
	patch(`${config.API_URL}/groups/bulk/active-inactive`, payload);
